import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { confirmAlert } from 'react-confirm-alert'
import { withRouter } from '../../components/funcs/BASES/withRouter'
import endPoints from '../../components/Consts/endPoints.json'
import notifyTargets from '../../components/Consts/notifyTargets.json'
import notificationTypes from '../../components/Consts/notificationTypes.json'
import { getTranslatation } from '../../locales/translate'

import { FaSave, FaFolder, FaEnvelope } from 'react-icons/fa'
import { FormLayout, MainLayout } from '../../components/features/Layouts'
import { InputOne } from '../../components/lib/input'
import { SelectOne } from '../../components/lib/select'
import { GridBlock } from '../../components/lib/grid'
import Grid from '@material-ui/core/Grid'

import * as DegisimlerActions from '../../redux/actions/Degisimler'
import * as AlldetailsActions from '../../redux/actions/Alldetails'
import UploadOne from '../../components/lib/upload/UploadOne'



var curr = new Date();
curr.setDate(curr.getDate() + 1);
var date = curr.toISOString().substring(0, 10);

var curr2 = new Date();
curr2.setDate(curr2.getDate() + 30);
var date2 = curr2.toISOString().substring(0, 10);

// ** 1- Aktif Bir Programi olan kullanıcılar
// ** 2- Tüm Kullanıcılar
// ** 3- Hiç satın alım yapmamış kullanıcılar
// ** 4- Aktif Bir Programi olmayan fakat herhangi bir programı daha oncee satın almıs olan kullanıcılar
//************************************************************** */
// ** 5- aynı gun antrenmanı olanlar
// ** 6- aynı gun antrenmanını tamamlamayanlar
// ** 7- su akdar gun gecmiste dukadar antrenman yapmayanlar
// ** 8- su akdar gun gecmiste dukadar antrenman yapanlara
class ChangesForm extends Component {
  constructor(props) {
    super(props)
    this.state = {

      onProcess: false,
      activeSection: 'form', // files

      id: '',
      fileOne: {},
      fileTwo: {},
      description: '',
      onPublish: 0,
      canPublish: 0,
      degisimlerim_order: 0,
      isAwarded: 0,
      startWeight: null,
      endWeight: null,
      waistLostCm: null,
      durationDays: null,
      likeCount: 0,
      
      translated: {
        en: {
          description: ''
        },
        tr: {
          description: ''
        }
      }

    }
    this.releatedRoutes = endPoints.find(aa => aa.name == 'Changes')?.routes;
  }

  componentDidMount() {

    try {
      var id = this.props.router.location.state.id
      this.setState({ id: id }, () => {
        this.props.actions.GetOne(
          this.state.id,
          () => {
            this.setState({ onProcess: true })
          },
          () => {
            setTimeout(
              function () {
                this.setState({ onProcess: false })
              }.bind(this),
              500
            )
          },
          data => {

            this.setPageForGETID(data)
          },
          () => { }
        )
      })
    } catch (err) { }
  }

  setPageForGETID = data => {
    console.log(data)
    this.setState({
      fileOne: data?.fileOne,
      fileTwo: data?.fileTwo,

      canPublish: data?.canPublish,
      description: data?.description,
      onPublish: data?.onPublish,
      degisimlerim_id: data?.degisimlerim_id,
      degisimlerim_order: data?.degisimlerim_order,
      isAwarded: data?.isAwarded,
      startWeight: data?.startWeight,
      endWeight: data?.endWeight,
      waistLostCm: data?.waistLostCm,
      durationDays: data?.durationDays,
      likeCount: data?.likeCount,
      translated: data?.translated || {
        en: { description: '' },
        tr: { description: '' }
      }
    })
  }

  submit = () => {
    this.props.actions.Update(
      this.state,
      () => {
        this.setState({ onProcess: true })
      },
      () => {
        setTimeout(() => {
          this.setState({ onProcess: false })
        }, 500)
      },
      () => {
        this.props.router.navigate(this.releatedRoutes.get)
      },
      () => { }
    )
  }

  setVal = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  // * Kullanicinin degisim metrikleri — temiz kart izgarasi (eski duz gri yazi yerine).
  renderMetrics = () => {
    const num = v => (v == null || v === '' ? null : Number(v))
    const sw = num(this.state.startWeight)
    const ew = num(this.state.endWeight)
    const lost = sw != null && ew != null ? Math.round((sw - ew) * 10) / 10 : null
    const fmt = (v, unit) => (v == null ? '—' : v + (unit ? ' ' + unit : ''))
    const cards = [
      { label: 'Başlangıç Kilo', value: fmt(sw, 'kg') },
      { label: 'Bitiş Kilo', value: fmt(ew, 'kg') },
      { label: 'Verilen Kilo', value: lost == null ? '—' : '-' + lost + ' kg', accent: true },
      { label: 'Belden İncelen', value: fmt(num(this.state.waistLostCm), 'cm'), accent: true },
      { label: 'Süre', value: fmt(num(this.state.durationDays), 'gün') },
      { label: 'Beğeni', value: String(this.state.likeCount ?? 0), accent: true },
    ]
    return (
      <div style={{ width: '100%', marginTop: 18, marginBottom: 8 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#2b2b3a', marginBottom: 10 }}>
          Değişim Bilgileri
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {cards.map((m, i) => (
            <div
              key={i}
              style={{
                flex: '1 1 140px',
                minWidth: 140,
                background: '#f5f4fb',
                border: '1px solid #e9e6fa',
                borderRadius: 12,
                padding: '12px 14px',
              }}
            >
              <div style={{ fontSize: 12, color: '#8a8a99', marginBottom: 4 }}>{m.label}</div>
              <div
                style={{ fontSize: 18, fontWeight: 700, color: m.accent ? '#651CFF' : '#2b2b3a' }}
              >
                {m.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  render() {

    return (
      <FormLayout
        naviIcon={<FaEnvelope size={30} color={'white'} />}
        recordIcon={<FaSave size={30} color={'white'} />}
        recordAction={this.submit}
        filesIcon={null}
        activeBack={() => {
          this.props.router.navigate(this.releatedRoutes?.get)
        }}
        loading={this.state.onProcess}
      >





        <GridBlock
          title={endPoints.find(aa => aa.name == 'Changes')?.menutext}
          container={true}
          xs={12}
          sm={12}
          lg={12}
        >

          <Grid item xs={12} sm={12} lg={6} style={{ padding: 10 }}>
            <img
              onClick={() => {
                window.open(process.env.REACT_APP_STORAGE_URL + 'Storage/' + (this.state.fileOne?.uuid))
              }}
              src={
                process.env.REACT_APP_STORAGE_URL + 'Storage/' + (this.state.fileOne?.uuid)
              }
              style={{ width: '100%', height: 400, objectFit: 'cover' }}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6} style={{ padding: 10 }}>
            <img

              onClick={() => {
                window.open(process.env.REACT_APP_STORAGE_URL + 'Storage/' + (this.state.fileTwo?.uuid))
              }}
              src={
                process.env.REACT_APP_STORAGE_URL + 'Storage/' + (this.state.fileTwo?.uuid)
              }
              style={{ width: '100%', height: 400, objectFit: 'cover' }}
            />
          </Grid>


          <InputOne
            multiline={true}
            minRows={8}
            color={'success'}
            variant='filled'
            margin='none'
            required
            fullWidth
            xs={12}
            sm={12}
            lg={12}
            id='description'
            label={getTranslatation('description', 'CHANGES')}
            name='description'
            value={this.state.description}
            onChange={this.setVal}
            // error={this.state.mailOrPhone_ERROR.length > 0}
            helperText={getTranslatation('descriptionHelper', 'CHANGES')}
          />


          <InputOne
            multiline={false}
            minRows={1}
            color={'success'}
            variant='filled'
            margin='none'
            required
            fullWidth
            xs={12}
            sm={12}
            lg={2}
            id='degisimlerim_order'
            label={getTranslatation('degisimlerim_order', 'CHANGES')}
            name='degisimlerim_order'
            value={this.state.degisimlerim_order}
            onChange={this.setVal}
            // error={this.state.mailOrPhone_ERROR.length > 0}
            helperText={getTranslatation('degisimlerim_orderHelper', 'CHANGES')}
          />

          <SelectOne
            // disabled={this.state.canPublish == 0}
            placeholder={getTranslatation('onPublish', 'CHANGES')}
            label={getTranslatation('onPublish', 'CHANGES')}
            helperText={getTranslatation('onPublishHelper', 'CHANGES')}
            xs={12}
            sm={12}
            lg={5}
            value={this.state.onPublish}
            onChange={this.setVal}
            name='onPublish'
            id='onPublish'
            options={[
              { value: 1, text: 'Yayında' },
              { value: 0, text: 'Yayında Değil' },
            ]}
          />

          <SelectOne
            placeholder={getTranslatation('isAwarded', 'CHANGES')}
            label={getTranslatation('isAwarded', 'CHANGES')}
            helperText={getTranslatation('isAwardedHelper', 'CHANGES')}
            name='isAwarded'
            id='isAwarded'
            value={this.state.isAwarded}
            onChange={this.setVal}
            xs={12}
            sm={12}
            lg={5}
            options={[
              { value: 1, text: 'Ödüllü' },
              { value: 0, text: 'Ödüllü Değil' },
            ]}
          />

          {this.renderMetrics()}

          <GridBlock
            title='Çeviriler (Translations)'
            container={true}
            xs={12}
            sm={12}
            lg={12}
          >
            <GridBlock
              title='İngilizce (EN)'
              container={true}
              xs={12}
              sm={12}
              lg={6}
            >
              <InputOne
                multiline={true}
                minRows={4}
                color={'success'}
                variant='filled'
                margin='none'
                fullWidth
                xs={12}
                sm={12}
                lg={12}
                id='translated_en_description'
                label='Description (EN)'
                name='translated_en_description'
                value={this.state.translated.en.description}
                onChange={(e) => {
                  this.setState({
                    translated: {
                      ...this.state.translated,
                      en: {
                        ...this.state.translated.en,
                        description: e.target.value
                      }
                    }
                  })
                }}
                helperText='İngilizce açıklama'
              />
            </GridBlock>

            <GridBlock
              title='Türkçe (TR)'
              container={true}
              xs={12}
              sm={12}
              lg={6}
            >
              <InputOne
                multiline={true}
                minRows={4}
                color={'success'}
                variant='filled'
                margin='none'
                fullWidth
                xs={12}
                sm={12}
                lg={12}
                id='translated_tr_description'
                label='Açıklama (TR)'
                name='translated_tr_description'
                value={this.state.translated.tr.description}
                onChange={(e) => {
                  this.setState({
                    translated: {
                      ...this.state.translated,
                      tr: {
                        ...this.state.translated.tr,
                        description: e.target.value
                      }
                    }
                  })
                }}
                helperText='Türkçe açıklama'
              />
            </GridBlock>
          </GridBlock>

        </GridBlock>



      </FormLayout>
    )
  }
}

//connect componenet with redux store
function mapStateToProps(state) {
  return {
    AlldetailsReducers: state.AlldetailsReducers
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      GetOne: bindActionCreators(DegisimlerActions.GetOne, dispatch),
      Update: bindActionCreators(DegisimlerActions.Update, dispatch),
    }
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChangesForm)
)
